module.exports = __webpack_public_path__ + "img/slogan.b5151e4f.webp";